module.exports = __webpack_public_path__ + "img/logo-white.e35f6966.svg";